export const avatarStyleHookMapping = {
  imageLoadingStatus: () => null
};